import { GridItem } from '../../../components/ui/grid-item'

type Props = {
  createdAt: string
  href: string
  previewImage: string | null
  previewText: string | null
  status: string | null
  title: string
  type: string
}

function BroadcastGridItem({
  createdAt,
  href,
  previewImage,
  previewText,
  status,
  title,
  type,
}: Props) {
  return (
    <GridItem
      createdAt={createdAt}
      href={href}
      previewImage={previewImage}
      previewText={previewText}
      status={status}
      title={title}
      type={type}
    />
  )
}

export { BroadcastGridItem }
